import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'industries';
export const industriesActions = makeActions(MODEL_NAME);

export const getAllIndustries = industriesActions.getAll;
export const editIndustries = industriesActions.edit;
export const createIndustries = industriesActions.create;
export const getByIdIndustries = industriesActions.getDataById;
